<template>
  <div class="tab-bar">
    <div class="tab-bar-item" v-for="item in list" :key="item.id">
      <div class="sideber-item" @click="checked(item.router)">
        <img :src="selected === item.id ? item.selectedIconPath : item.pagePath" alt="">
        <div :class="selected === item.id ? 'activeText' : ''">{{item.text}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Sidebar',
  data () {
    return {
      list: [{
        pagePath: require('../assets/icon13.png'),
        selectedIconPath: require('../assets/icon14.png'),
        text: '首页',
        router: 'IndexPage',
        id: 1
      },
      {
        pagePath: require('../assets/icon15.png'),
        selectedIconPath: require('../assets/icon16.png'),
        text: '课程',
        router: 'course',
        id: 2
      },
      {
        pagePath: require('../assets/icon17.png'),
        selectedIconPath: require('../assets/icon18.png'),
        text: '订单',
        router: 'order',
        id: 3
      },
      {
        pagePath: require('../assets/icon19.png'),
        selectedIconPath: require('../assets/icon20.png'),
        text: '我的',
        router: 'mine',
        id: 4
      }
      ],
      form: {
        index: true,
        class: false,
        order: false,
        mine: false
      }
    }
  },
  props: ['selected'],
  methods: {
    checked: function (i) {
      this.$router.push({name: i})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.sideber {
  width: 100%;
  height: 70px;
  display: flex;
  position:fixed;
  bottom: 0;
}
.sideber-item {
  flex: 1;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-top: 10px;
}
.sideber-item img{
  width: 30px;
  height: 30px;
}
.sideber-item div{
  font-family: "PingFang-SC-Medium";
  text-align: center;
  color: #666;
  font-size: 14px;
}
.activeText{
  color: #ffb949!important;
}
.tab-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  display: flex;
  box-shadow: 0 -2px 1px rgba(0, 0, 0, 0.2);
}
.tab-bar-item {
  flex: 1;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue